export default function ReadMore({ text, className }) {
  const [full, setFull] = useState(false)
  const t = useI18n()
  const __html = text.escaped()
  const lines = __html.split('<br>')
  const lineCount = lines.length
  const showLineCount = 8

  const moreThanLimit = lineCount >= showLineCount + 3

  useEffect(() => {
    setFull(false)
  }, [text])

  const showFull = () => {
    if (full) return true
    return !moreThanLimit
  }
  if (showFull()) return <div className={ className } { ...text.rawHtml() } />
  const slicedText = [
    ...lines.slice(0, showLineCount),
    lines[showLineCount].slice(0, 14)
  ] .join('<br>')

  return (
    <div className={ className }>
      <span dangerouslySetInnerHTML={ { __html: slicedText } }></span>
      <span className='cursor-pointer font-bold'
        onClick={ () => setFull(true) }
      > ... { t('common:more') }</span>
    </div>
  )
}
